import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import {sortStationsByNumber} from '../../libs/utility';

export default class StationTankSelect extends Component {
	render () {
		const {
			label = 'Station',
			path,
			controller,
			stations,
			readOnly = false,
			helpText,
		} = this.props;

		const { state } = controller;
		const { formFieldError } = state;

		if (!_.isFunction(controller.onChange)) {
			console.error('Controller missing handle change');
			return;
		}

		if (!_.isObject(formFieldError)) {
			console.error('Controller missing formFieldError object');
			return;
		}

		//let value, onChange, error;
		const value = _.get(state, path, '');
		const error = _.get(formFieldError, path);
		const hasError = !!error;
		const onChange = event => controller.onChange(event, path);

		const sorted = sortStationsByNumber(stations);

		const j = _.random(9999999);

		return (<Grid spacing={3} container>
			<Grid item xs={12} md={12}>
				<FormControl fullWidth={true} error={hasError} margin={"dense"}>
					<InputLabel htmlFor={`station${j}`}>{label}</InputLabel>
					<Select
						value={value}
						onChange={onChange}
						input={<Input id={`station${j}`} readOnly={readOnly}/>}
						MenuProps={{
							PaperProps: {
								style: {
									transform: 'translate3d(0, 0, 0)'
								}
							},
							onEnter : () => {
								setTimeout(() => {
									if (document.activeElement) {
										document.activeElement.blur();
									}
								}, 500);
							}
						}}
					>
						{sorted.map((station, i) => {
							const { stationId, number, name} = station;
							return (
								<MenuItem key={i} value={stationId}>
									{number} - {name}
								</MenuItem>
							);
						})}
					</Select>

					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

StationTankSelect.propTypes = {
	label : PropTypes.string,
	path: PropTypes.array.isRequired,
	controller: PropTypes.object.isRequired,
	stations : PropTypes.array.isRequired,
	helpText : PropTypes.string,
	readOnly : PropTypes.bool,
};

